module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/down-arrow-e27875b505a8844c7115aaa709e4384e.svg";